import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-alcohol-template-info',
  imports: [TranslatePipe],
  templateUrl: './alcohol-template-info.component.html',
  styleUrls: [
    './alcohol-template-info.component.scss',
    '../template-shared.stylesheet.scss',
  ],
})
export class AlcoholTemplateInfoComponent {
  translationPrefix = input('', { transform: appendPrefix });
}
function appendPrefix(value: string | undefined): string {
  return value + 'alcohol.';
}
